import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedRoutingModule} from './shared-routing.module';
import {BaseComponent} from './base/base.component';
import {ConfirmationDialogComponent} from './confirmation-dialog/confirmation-dialog.component';
import {BreadscrumbComponent} from './ui/breadscrumb/breadscrumb.component';
import {BottomNavComponent} from './ui/bottom-nav/bottom-nav.component';
import {SidenavComponent} from './ui/sidenav/sidenav.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatListModule} from '@angular/material/list';
import {SystemSettingsMenuComponent} from './ui/system-settings-menu/system-settings-menu.component';
import {LoadingIndicatorComponent} from './ui/LoadingIndicator/LoadingIndicator.component';
import {HasPermissionDirective} from '../../directives/has-permission.directive';
import {HeaderComponent} from './layouts/header/header.component';
import {FooterComponent} from './layouts/footer/footer.component';
import {AppLayoutComponent} from './layouts/app-layout/app-layout.component';
import {LoginLayoutComponent} from '../admin/components/login/login-layout/login-layout.component';
import {SystemSettingsLayoutComponent} from './layouts/system-settings-layout/system-settings-layout.component';

import {NgxLoadingModule} from 'ngx-loading';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MessagesMenuComponent} from './ui/messages-menu/messages-menu.component';
import {MessageMenuItemComponent} from './ui/messages-menu/message-menu-item/message-menu-item.component';
import {MatTreeModule} from '@angular/material/tree';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
// import {BrowserModule} from '@angular/platform-browser';
import {ScrollingModule} from '@angular/cdk/scrolling';

import {SelectDropDownModule} from 'ngx-select-dropdown';
import {ColorPickerModule} from 'ngx-color-picker';
// import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCardModule} from '@angular/material/card';

import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatInputModule} from '@angular/material/input';
import {MatRippleModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTabsModule} from '@angular/material/tabs';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatExpansionModule} from '@angular/material/expansion';

// import {DropzoneModule} from 'ngx-dropzone-wrapper';
import {OwlModule} from 'ngx-owl-carousel';
import {MatRadioModule} from '@angular/material/radio';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {LayoutModule} from '@angular/cdk/layout';
import {MatToolbarModule} from '@angular/material/toolbar';
import {UserNotificationComponent} from './ui/user-notification/user-notification.component';
import {NotificationItemComponent} from './ui/user-notification/notification-item/notification-item.component';
import {AllNotificationsComponent} from './ui/user-notification/all-notifications/all-notifications.component';
import {NotificationDetailsComponent} from './ui/user-notification/notification-details/notification-details.component';
import {BaseService} from '../../services/base.service';

import {FilterPipe} from './filters/filter.pipe';
import {StripHtmlPipe} from './filters/strip-html.pipe';
import {PageNotFoundComponent} from './error_pages/page-not-found/page-not-found.component';
import {AccessDeniedComponent} from './error_pages/access-denied/access-denied.component';
import {EscapeHtmlPipe} from '../../pipe/pipes/keep-html.pipe';
import {CustomerFilterPipe} from './filters/customer-filter.pipe';
import {TruncatePipe} from './filters/truncate.pipe';
import {LoaderComponent} from './ui/loader/loader.component';
import {DealsFilterPipe} from './filters/deals-filter.pipe';
import {WidgetBaseComponent} from './widget-base/widget-base.component';

import {ImageSliderComponent} from './layouts/image-slider/image-slider.component';
import {CarouselModule} from "ngx-owl-carousel-o";
import {RouterModule} from "@angular/router";
import {MatAutocompleteModule} from "@angular/material/autocomplete";

@NgModule({
    declarations: [
        EscapeHtmlPipe,
        FilterPipe,
        StripHtmlPipe,
        MessagesMenuComponent,
        MessageMenuItemComponent,
        UserNotificationComponent,
        NotificationItemComponent,
        AllNotificationsComponent,
        NotificationDetailsComponent,
        BaseComponent,
        AppLayoutComponent,
        LoginLayoutComponent,
        PageNotFoundComponent,
        AccessDeniedComponent,
        BreadscrumbComponent,

        BottomNavComponent,
        SidenavComponent,
        ConfirmationDialogComponent,
        SystemSettingsMenuComponent,
        LoadingIndicatorComponent,
        SystemSettingsLayoutComponent,
        HasPermissionDirective,
        HeaderComponent,
        FooterComponent,
        AccessDeniedComponent,
        PageNotFoundComponent,
        CustomerFilterPipe,
        TruncatePipe,
        LoaderComponent,
        DealsFilterPipe,
        WidgetBaseComponent,
        ImageSliderComponent,


    ],
    imports: [
        MatAutocompleteModule,
        CommonModule,
        RouterModule,
        SharedRoutingModule,
        MatSidenavModule,
        MatListModule,
        NgxLoadingModule,
        FormsModule,
        ReactiveFormsModule,
        MatTreeModule,
        MatIconModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        ScrollingModule,

        SelectDropDownModule,
        ColorPickerModule,
        MatButtonModule,
        MatProgressBarModule,
        MatFormFieldModule,
        MatCardModule,

        MatCheckboxModule,
        MatInputModule,
        MatRippleModule,
        MatSelectModule,
        MatTooltipModule,
        MatMenuModule,
        MatGridListModule,
        MatSidenavModule,
        MatDialogModule,
        MatTabsModule,
        MatListModule,
        MatIconModule,
        DragDropModule,
        MatExpansionModule,
        //  BrowserModule,
        ReactiveFormsModule,

        // DropzoneModule,
        OwlModule,
        MatRadioModule,
        MatButtonToggleModule,

        LayoutModule,
        MatToolbarModule,
        NgxLoadingModule,

        CarouselModule
    ],
    exports: [
        FilterPipe,
        StripHtmlPipe,
        EscapeHtmlPipe,
        BaseComponent,
        ConfirmationDialogComponent,
        SystemSettingsMenuComponent,
        LoadingIndicatorComponent,
        SidenavComponent,
        HasPermissionDirective,
        SystemSettingsLayoutComponent,
        AppLayoutComponent,
        LoginLayoutComponent,

        BreadscrumbComponent,
        CommonModule,
        SharedRoutingModule,
        MatSidenavModule,
        MatListModule,

        NgxLoadingModule,
        FormsModule,
        ReactiveFormsModule,
        MatTreeModule,
        MatIconModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,

        ScrollingModule,
        SelectDropDownModule,
        ColorPickerModule,
        MatButtonModule,
        MatProgressBarModule,
        MatFormFieldModule,
        MatCardModule,
        MatCheckboxModule,
        MatInputModule,
        MatRippleModule,
        MatSelectModule,
        MatTooltipModule,
        MatMenuModule,

        MatGridListModule,
        MatSidenavModule,
        MatDialogModule,
        // BrowserAnimationsModule,
        MatTabsModule,
        MatListModule,
        MatIconModule,
        DragDropModule,
        MatExpansionModule,
        // HttpClientModule,

        ReactiveFormsModule,

        // DropzoneModule,
        OwlModule,
        MatRadioModule,
        MatButtonToggleModule,
        PageNotFoundComponent,
        AccessDeniedComponent,
        CustomerFilterPipe,
        TruncatePipe,
        LoaderComponent,
        WidgetBaseComponent

    ],
    providers: [BaseService,

    ]
})
export class SharedModule {
}
